import {ENumber, Expression} from '@packages/systems/wfdl-ast';
import {Expressions, Plugins, Variable} from '@packages/systems/wfdl';
import {qualify} from '@packages/systems/wfdl-Qualified';

export const numberToTextVariable = Variable.qualified(
  qualify(Plugins.name('Basic'), 'numberToText')
);

export const numberValueCreator = (expr: Expression | undefined) => {
  if (expr) {
    // If current expr is binding, return the (not transformed) number binding
    if (Expressions.isBinding(expr)) {
      // Remove the `numberToText` layer
      const fnCall = Expressions.getCall(expr);
      const fnVariable = fnCall ? Expressions.getVariable(fnCall.fun) : null;
      if (
        fnCall &&
        fnVariable &&
        Variable.equals(fnVariable)(numberToTextVariable)
      ) {
        return fnCall.arg;
      }
      return expr;
    }
    // If we have a number, return it.
    const number = Expressions.getNumber(expr);
    if (number !== null) {
      return expr;
    }
    // Get numeric string value of the expr
    const txtVal = Expressions.getText(expr);
    const numVal = txtVal ? Number(txtVal) : null;
    if (numVal === null || isNaN(numVal)) {
      return ENumber(0);
    }
    return ENumber(numVal);
  }
  // fallback to default expr
  return ENumber(0);
};
